import { render, staticRenderFns } from "./DeviceDataIcon.vue?vue&type=template&id=55ffbbe5&scoped=true"
import script from "./DeviceDataIcon.vue?vue&type=script&lang=ts"
export * from "./DeviceDataIcon.vue?vue&type=script&lang=ts"
import style0 from "./DeviceDataIcon.vue?vue&type=style&index=0&id=55ffbbe5&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ffbbe5",
  null
  
)

export default component.exports